import Vue from 'vue'

// 查询字典项目
const queryDict = (data) => {   
    return Vue.prototype.$http.get('/api/v3/ops/dicts', {
        params: data
    })
}

// 增加字典项目
const addDict = (data) => {
    
    return Vue.prototype.$http.post('/api/v3/ops/dicts', data)
}

export {
    queryDict,
    addDict
}


// WEBPACK FOOTER //
// ./src/data/org/dicts.js